var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.23966L18.3438 15.7917H2.65629L10.5 2.23966ZM0.854212 14.7501C0.0521283 16.1355 1.05213 17.8751 2.65629 17.8751H18.3438C19.948 17.8751 20.948 16.1355 20.1459 14.7501L12.3021 1.198C11.5 -0.187419 9.50004 -0.187419 8.69796 1.198L0.854212 14.7501ZM9.45838 7.45841V9.54175C9.45838 10.1147 9.92713 10.5834 10.5 10.5834C11.073 10.5834 11.5417 10.1147 11.5417 9.54175V7.45841C11.5417 6.8855 11.073 6.41675 10.5 6.41675C9.92713 6.41675 9.45838 6.8855 9.45838 7.45841ZM9.45838 12.6667H11.5417V14.7501H9.45838V12.6667Z",
    fill: "#E22B3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.59cf8f58.svg";
export { ForwardRef as ReactComponent };